module.exports = __webpack_public_path__ + "static/media/packet-o.b9575214.png";